import { makeStyles } from '@material-ui/core';

import { neutral } from '../../../../shared/styles/colors';

import type { GlobalMode } from '../../shared/types';

interface Props {
  globalMode?: GlobalMode;
}

export default makeStyles(() => ({
  root: ({ globalMode = false }: Props) => ({
    width: 'fit-content',
    height: 'stretch',
    padding: '0.25rem 0.5rem',
    display: 'flex',
    gap: globalMode ? '0.25rem' : 0,
    alignItems: 'center',
    textAlign: globalMode ? 'center' : 'left',
    border: `1px solid ${neutral['20']}`,
    borderRadius: '0.5rem',
    color: neutral['100'],
    backgroundColor: neutral.white,
    cursor: globalMode ? 'pointer' : 'auto',
    '&:focus-visible': {
      outline: 'none',
    },
    '& img': {
      display: 'none',
    },
    '@media (width >= 768px)': {
      '& img': {
        display: 'block',
      },
    },
  }),
  checkinCodeTextLine: ({ globalMode = false }: Props) => ({
    fontWeight: 600,
    fontSize: globalMode ? '0.675rem' : '0.875rem',
    lineHeight: globalMode ? '1rem' : '1.25rem',
    '@media (width >= 768px)': {
      fontSize: '0.875rem',
      lineHeight: '1.25rem',
    },
  }),
}));
